import { render, staticRenderFns } from "./FollowupTooptip.vue?vue&type=template&id=6c91d225"
import script from "./FollowupTooptip.vue?vue&type=script&lang=js"
export * from "./FollowupTooptip.vue?vue&type=script&lang=js"
import style0 from "./FollowupTooptip.vue?vue&type=style&index=0&id=6c91d225&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports